module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 33);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("url");

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Configuration; });
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
    }
    return Configuration;
}());



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _content_block__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _content_block__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_content_block__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _content_block_base__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_content_block_base__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_base__WEBPACK_IMPORTED_MODULE_1__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_base__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_expired_main_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _content_block_expired_main_block__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_content_block_expired_main_block__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_expired_main_block__WEBPACK_IMPORTED_MODULE_2__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_expired_main_block__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_expired_main_block_all_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
/* harmony import */ var _content_block_expired_main_block_all_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_content_block_expired_main_block_all_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_expired_main_block_all_of__WEBPACK_IMPORTED_MODULE_3__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_expired_main_block_all_of__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_expired_main_block_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
/* harmony import */ var _content_block_expired_main_block_data__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_content_block_expired_main_block_data__WEBPACK_IMPORTED_MODULE_4__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_expired_main_block_data__WEBPACK_IMPORTED_MODULE_4__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_expired_main_block_data__WEBPACK_IMPORTED_MODULE_4__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_html_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10);
/* harmony import */ var _content_block_html_content__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_content_block_html_content__WEBPACK_IMPORTED_MODULE_5__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_html_content__WEBPACK_IMPORTED_MODULE_5__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_html_content__WEBPACK_IMPORTED_MODULE_5__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_html_content_all_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
/* harmony import */ var _content_block_html_content_all_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_content_block_html_content_all_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_html_content_all_of__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_html_content_all_of__WEBPACK_IMPORTED_MODULE_6__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_html_content_data__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12);
/* harmony import */ var _content_block_html_content_data__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_content_block_html_content_data__WEBPACK_IMPORTED_MODULE_7__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_html_content_data__WEBPACK_IMPORTED_MODULE_7__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_html_content_data__WEBPACK_IMPORTED_MODULE_7__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_lines_content_view__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13);
/* harmony import */ var _content_block_lines_content_view__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_content_block_lines_content_view__WEBPACK_IMPORTED_MODULE_8__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_lines_content_view__WEBPACK_IMPORTED_MODULE_8__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_lines_content_view__WEBPACK_IMPORTED_MODULE_8__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_parking_page_block__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14);
/* harmony import */ var _content_block_parking_page_block__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_content_block_parking_page_block__WEBPACK_IMPORTED_MODULE_9__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_parking_page_block__WEBPACK_IMPORTED_MODULE_9__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_parking_page_block__WEBPACK_IMPORTED_MODULE_9__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_parking_page_block_all_of__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15);
/* harmony import */ var _content_block_parking_page_block_all_of__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_content_block_parking_page_block_all_of__WEBPACK_IMPORTED_MODULE_10__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_parking_page_block_all_of__WEBPACK_IMPORTED_MODULE_10__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_parking_page_block_all_of__WEBPACK_IMPORTED_MODULE_10__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_parking_page_block_data__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16);
/* harmony import */ var _content_block_parking_page_block_data__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_content_block_parking_page_block_data__WEBPACK_IMPORTED_MODULE_11__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_parking_page_block_data__WEBPACK_IMPORTED_MODULE_11__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_parking_page_block_data__WEBPACK_IMPORTED_MODULE_11__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_type__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContentBlockType", function() { return _content_block_type__WEBPACK_IMPORTED_MODULE_12__["a"]; });

/* harmony import */ var _content_block_zone__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18);
/* harmony import */ var _content_block_zone__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_content_block_zone__WEBPACK_IMPORTED_MODULE_13__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_zone__WEBPACK_IMPORTED_MODULE_13__) if(["ContentBlockType","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_zone__WEBPACK_IMPORTED_MODULE_13__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _content_block_zone_declaration__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19);
/* harmony import */ var _content_block_zone_declaration__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_content_block_zone_declaration__WEBPACK_IMPORTED_MODULE_14__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _content_block_zone_declaration__WEBPACK_IMPORTED_MODULE_14__) if(["ContentBlockType","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _content_block_zone_declaration__WEBPACK_IMPORTED_MODULE_14__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _error_code__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(20);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return _error_code__WEBPACK_IMPORTED_MODULE_15__["a"]; });

/* harmony import */ var _error_response__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21);
/* harmony import */ var _error_response__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_error_response__WEBPACK_IMPORTED_MODULE_16__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _error_response__WEBPACK_IMPORTED_MODULE_16__) if(["ContentBlockType","ErrorCode","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _error_response__WEBPACK_IMPORTED_MODULE_16__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _get_echo_response__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22);
/* harmony import */ var _get_echo_response__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_get_echo_response__WEBPACK_IMPORTED_MODULE_17__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _get_echo_response__WEBPACK_IMPORTED_MODULE_17__) if(["ContentBlockType","ErrorCode","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _get_echo_response__WEBPACK_IMPORTED_MODULE_17__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _get_expired_page_response__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23);
/* harmony import */ var _get_expired_page_response__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_get_expired_page_response__WEBPACK_IMPORTED_MODULE_18__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _get_expired_page_response__WEBPACK_IMPORTED_MODULE_18__) if(["ContentBlockType","ErrorCode","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _get_expired_page_response__WEBPACK_IMPORTED_MODULE_18__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(24);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_image__WEBPACK_IMPORTED_MODULE_19__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _image__WEBPACK_IMPORTED_MODULE_19__) if(["ContentBlockType","ErrorCode","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _image__WEBPACK_IMPORTED_MODULE_19__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _lang__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(25);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Lang", function() { return _lang__WEBPACK_IMPORTED_MODULE_20__["a"]; });

/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_link__WEBPACK_IMPORTED_MODULE_21__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _link__WEBPACK_IMPORTED_MODULE_21__) if(["ContentBlockType","ErrorCode","Lang","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _link__WEBPACK_IMPORTED_MODULE_21__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _link_view__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LinkView", function() { return _link_view__WEBPACK_IMPORTED_MODULE_22__["a"]; });

/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(28);
/* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_page__WEBPACK_IMPORTED_MODULE_23__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _page__WEBPACK_IMPORTED_MODULE_23__) if(["ContentBlockType","ErrorCode","Lang","LinkView","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _page__WEBPACK_IMPORTED_MODULE_23__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _page_meta__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29);
/* harmony import */ var _page_meta__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_page_meta__WEBPACK_IMPORTED_MODULE_24__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _page_meta__WEBPACK_IMPORTED_MODULE_24__) if(["ContentBlockType","ErrorCode","Lang","LinkView","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _page_meta__WEBPACK_IMPORTED_MODULE_24__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _page_open_graph__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30);
/* harmony import */ var _page_open_graph__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_page_open_graph__WEBPACK_IMPORTED_MODULE_25__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _page_open_graph__WEBPACK_IMPORTED_MODULE_25__) if(["ContentBlockType","ErrorCode","Lang","LinkView","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _page_open_graph__WEBPACK_IMPORTED_MODULE_25__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _response_error__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(31);
/* harmony import */ var _response_error__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_response_error__WEBPACK_IMPORTED_MODULE_26__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _response_error__WEBPACK_IMPORTED_MODULE_26__) if(["ContentBlockType","ErrorCode","Lang","LinkView","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _response_error__WEBPACK_IMPORTED_MODULE_26__[key]; }) }(__WEBPACK_IMPORT_KEY__));





























/***/ }),
/* 5 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 16 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentBlockType; });
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Тип контентного блока страницы.
 * @export
 * @enum {string}
 */
var ContentBlockType;
(function (ContentBlockType) {
    ContentBlockType["LinesContentView"] = "linesContentView";
    ContentBlockType["HtmlContent"] = "htmlContent";
    ContentBlockType["ExpiredMainBlock"] = "expiredMainBlock";
    ContentBlockType["ParkingPageBlock"] = "parkingPageBlock";
})(ContentBlockType || (ContentBlockType = {}));


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorCode; });
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Код ошибки API.  Подробнее см. в base.yaml.
 * @export
 * @enum {string}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["BaseError"] = "base_error";
    ErrorCode["BadRequest"] = "bad_request";
    ErrorCode["JsonSyntaxError"] = "json_syntax_error";
    ErrorCode["JsonTypeError"] = "json_type_error";
    ErrorCode["EmptyRequestBody"] = "empty_request_body";
    ErrorCode["UnexpectedEndOfRequestBody"] = "unexpected_end_of_request_body";
    ErrorCode["InternalError"] = "internal_error";
    ErrorCode["DomainNotFound"] = "domain_not_found";
})(ErrorCode || (ErrorCode = {}));


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Lang; });
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Язык ответа или запроса.
 * @export
 * @enum {string}
 */
var Lang;
(function (Lang) {
    Lang["Ru"] = "ru";
    Lang["En"] = "en";
})(Lang || (Lang = {}));


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkView; });
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Способ отображения ссылки: * default – в виде обычной текстовой ссылки; * buttonFilled – в виде кнопки со сплошной заливкой цветом (обычно синим); * buttonOutlined – в виде кнопки без заливки, но с цветной окантовкой (обычно синей);
 * @export
 * @enum {string}
 */
var LinkView;
(function (LinkView) {
    LinkView["Default"] = "default";
    LinkView["ButtonFilled"] = "buttonFilled";
    LinkView["ButtonOutlined"] = "buttonOutlined";
})(LinkView || (LinkView = {}));


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ ExpiredApiAxiosParamCreator; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ ExpiredApiFp; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ ExpiredApiFactory; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ expired_api_ExpiredApi; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ HealthApiAxiosParamCreator; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ HealthApiFp; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ HealthApiFactory; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ health_api_HealthApi; });

// EXTERNAL MODULE: external "tslib"
var external_tslib_ = __webpack_require__(0);

// EXTERNAL MODULE: external "url"
var external_url_ = __webpack_require__(2);

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__(1);
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/base.ts
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// Some imports not used depending on template conditions
// @ts-ignore

var BASE_PATH = 'http://localhost/webgw/web/bff/parking'.replace(/\/+$/, '');
/**
 *
 * @export
 */
var COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 *
 * @export
 * @class BaseAPI
 */
var base_BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (axios === void 0) { axios = external_axios_default.a; }
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var base_RequiredError = /** @class */ (function (_super) {
    Object(external_tslib_["__extends"])(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = 'RequiredError';
        return _this;
    }
    return RequiredError;
}(Error));


// CONCATENATED MODULE: ./src/client/expired-api.ts
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// Some imports not used depending on template conditions
// @ts-ignore

/**
 * ExpiredApi - axios parameter creator
 * @export
 */
var ExpiredApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Возвращает данные для expired page.
         * @param {string} [xDomain] Домен (обычно в punycode).
         * @param {Lang} [xLanguage] Язык запроса и ответа.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiredPage: function (xDomain, xLanguage, options) {
            if (options === void 0) { options = {}; }
            return Object(external_tslib_["__awaiter"])(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return Object(external_tslib_["__generator"])(this, function (_a) {
                    localVarPath = "/api/v1/expired/page";
                    localVarUrlObj = external_url_["parse"](localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xDomain !== undefined && xDomain !== null) {
                        localVarHeaderParameter['X-Domain'] = String(xDomain);
                    }
                    if (xLanguage !== undefined && xLanguage !== null) {
                        localVarHeaderParameter['X-Language'] = String(xLanguage);
                    }
                    localVarUrlObj.query = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    // @ts-ignore
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: external_url_["format"](localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ExpiredApi - functional programming interface
 * @export
 */
var ExpiredApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Возвращает данные для expired page.
         * @param {string} [xDomain] Домен (обычно в punycode).
         * @param {Lang} [xLanguage] Язык запроса и ответа.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiredPage: function (xDomain, xLanguage, options) {
            return Object(external_tslib_["__awaiter"])(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return Object(external_tslib_["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ExpiredApiAxiosParamCreator(configuration).getExpiredPage(xDomain, xLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = external_axios_default.a; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ExpiredApi - factory interface
 * @export
 */
var ExpiredApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Возвращает данные для expired page.
         * @param {string} [xDomain] Домен (обычно в punycode).
         * @param {Lang} [xLanguage] Язык запроса и ответа.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiredPage: function (xDomain, xLanguage, options) {
            return ExpiredApiFp(configuration)
                .getExpiredPage(xDomain, xLanguage, options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ExpiredApi - object-oriented interface
 * @export
 * @class ExpiredApi
 * @extends {BaseAPI}
 */
var expired_api_ExpiredApi = /** @class */ (function (_super) {
    Object(external_tslib_["__extends"])(ExpiredApi, _super);
    function ExpiredApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Возвращает данные для expired page.
     * @param {string} [xDomain] Домен (обычно в punycode).
     * @param {Lang} [xLanguage] Язык запроса и ответа.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiredApi
     */
    ExpiredApi.prototype.getExpiredPage = function (xDomain, xLanguage, options) {
        var _this = this;
        return ExpiredApiFp(this.configuration)
            .getExpiredPage(xDomain, xLanguage, options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExpiredApi;
}(base_BaseAPI));


// CONCATENATED MODULE: ./src/client/health-api.ts
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// Some imports not used depending on template conditions
// @ts-ignore

/**
 * HealthApi - axios parameter creator
 * @export
 */
var HealthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Проверяет доступность API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcho: function (options) {
            if (options === void 0) { options = {}; }
            return Object(external_tslib_["__awaiter"])(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return Object(external_tslib_["__generator"])(this, function (_a) {
                    localVarPath = "/api/v1/echo";
                    localVarUrlObj = external_url_["parse"](localVarPath, true);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarUrlObj.query = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarUrlObj.query), localVarQueryParameter), options.query);
                    // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
                    // @ts-ignore
                    delete localVarUrlObj.search;
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: external_url_["format"](localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * HealthApi - functional programming interface
 * @export
 */
var HealthApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Проверяет доступность API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcho: function (options) {
            return Object(external_tslib_["__awaiter"])(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return Object(external_tslib_["__generator"])(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, HealthApiAxiosParamCreator(configuration).getEcho(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = external_axios_default.a; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = Object(external_tslib_["__assign"])(Object(external_tslib_["__assign"])({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * HealthApi - factory interface
 * @export
 */
var HealthApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Проверяет доступность API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcho: function (options) {
            return HealthApiFp(configuration)
                .getEcho(options)
                .then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
var health_api_HealthApi = /** @class */ (function (_super) {
    Object(external_tslib_["__extends"])(HealthApi, _super);
    function HealthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Проверяет доступность API.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    HealthApi.prototype.getEcho = function (options) {
        var _this = this;
        return HealthApiFp(this.configuration)
            .getEcho(options)
            .then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthApi;
}(base_BaseAPI));


// CONCATENATED MODULE: ./src/api.ts
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.2
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpiredApiAxiosParamCreator", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpiredApiFp", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpiredApiFactory", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpiredApi", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HealthApiAxiosParamCreator", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HealthApiFp", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HealthApiFactory", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HealthApi", function() { return _api__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony import */ var _configuration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Configuration", function() { return _configuration__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _model__WEBPACK_IMPORTED_MODULE_2__) if(["ExpiredApiAxiosParamCreator","ExpiredApiFp","ExpiredApiFactory","ExpiredApi","HealthApiAxiosParamCreator","HealthApiFp","HealthApiFactory","HealthApi","Configuration","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _model__WEBPACK_IMPORTED_MODULE_2__[key]; }) }(__WEBPACK_IMPORT_KEY__));
// tslint:disable
/**
 * parking-api-v1
 * API для парковочных страниц доменов.  Первичная разработка API сделана для страниц типа \"expired\", т.е. для [страниц просроченных доменов](https://confluence.nic.ru/pages/viewpage.action?pageId=5867774).  В будущем планируется использовать эту схему API и для других типов парковочных страниц: status, blocked и т.п.  ## Полезные ссылки  * [Архитектура](https://confluence.nic.ru/pages/viewpage.action?pageId=5869422) * [ТЗ](https://confluence.nic.ru/pages/viewpage.action?pageId=15402208) * [Git](https://git.nic.ru/dev-web/bff)
 *
 * The version of the OpenAPI document: 1.0.1
 * Contact: vkulagin@nic.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */





/***/ })
/******/ ]);